import { ModelPath } from "@com.mgmtp.a12.base/base-model-api/lib/main/model";

const configuration = [{ elementName: "root" }, { elementName: "configuration" }] as const;

export const configurationEntryMatchPath = [...configuration, undefined] as const;

export const fieldMappingMatchPath = [
	...configurationEntryMatchPath,
	{ elementName: "mapfile" },
	{ elementName: "fieldMapping" }
] as const;

export const anyMapExpressionMatchPath = [
	...fieldMappingMatchPath,
	undefined,
	{ elementName: "mapExpression" }
] as const;

export const targetMapExpressionMatchPath = [
	...fieldMappingMatchPath,
	{ elementName: "target" },
	{ elementName: "mapExpression" }
] as const;

export const sourceMapExpressionMatchPath = [
	...fieldMappingMatchPath,
	{ elementName: "source" },
	{ elementName: "mapExpression" }
] as const;

export const externalPathSourceSelectMatchPath = [
	...configurationEntryMatchPath,
	{ elementName: "externalPathSource" },
	{ elementName: "select" },
	{ elementName: "selectedId" }
] as const;

export const externalPathSourceFileMatchPath = [
	...configurationEntryMatchPath,
	{ elementName: "externalPathSource" },
	{ elementName: "upload" },
	{ elementName: "file" }
] as const;

export const modelIdMapEntriesMatchPath = [...configurationEntryMatchPath, { elementName: "entries" }] as const;

export const arsMapArsMatchPath = [
	...configurationEntryMatchPath,
	{ elementName: "entries" },
	undefined,
	{ elementName: "ars" }
] as const;

export const arsMapMappingValueMatchPath = [
	...configurationEntryMatchPath,
	{ elementName: "entries" },
	undefined,
	{ elementName: "mappings" },
	undefined,
	undefined
] as const;

export const arsMapMappingsMatchPath = [
	...configurationEntryMatchPath,
	{ elementName: "entries" },
	{ elementName: "mappings" }
] as const;

export const arsMapAdditionalFieldEnabledMatchPath = [
	...configurationEntryMatchPath,
	{ elementName: "additionalFieldEnabled" }
] as const;

export const arsMapAdditionalFieldMatchPath = [
	...configurationEntryMatchPath,
	{ elementName: "entries" },
	undefined,
	{ elementName: "mappings" },
	undefined,
	{ elementName: "additionalField" }
] as const;

export const typedGroupMapValueMatchPath = [
	...configuration,
	undefined,
	{ elementName: "entries" },
	{ elementName: "value" }
] as const;

export const fachverfahrenTypePath: ModelPath = [
	{ elementName: "root" },
	{ elementName: "fachverfahren" },
	{ elementName: "metaData" },
	{ elementName: "type" }
] as const;
